import 'twin.macro';

import { ProfileCardSectionProps } from './type';

const ProfileSection = ({ refId, intervieweeName, intervieweeEmail }: ProfileCardSectionProps) => {
  return (
    <div tw="w-full grid grid-cols-[1fr] gap-y-[2px]">
      <p tw="font-light text-sm text-gray-600">{refId ? `${refId}` : ''}</p>
      <p tw="text-3xl font-bold">{intervieweeName}</p>
      <p tw="font-light text-gray-600">{intervieweeEmail}</p>
    </div>
  );
};

export default ProfileSection;
